import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//import avatar from "../../../assets/profile.png";
import iconoCamara from "../../../../assets/icono_camara-01.png";
import Bienvenido from "../../../../assets/Bienvenido-01.png";
import Logo from "../../../../assets/logo2_white_Mesa.png";
import { LuEye, LuEyeOff } from "react-icons/lu";

import toast, { Toaster } from "react-hot-toast";
import { useFormik } from "formik";

import { useAuthStore } from "../../../../store/store";
import { usernamePasswordLoginValidate } from "../../../../helper/validate";
import * as api from "helper/helper";
import styles from "../../../../styles/Username.module.css";
import "../Dashboard/dashboard.css";
import innerStyle from "./Login.module.css";
import convertToBase64 from "../../../../helper/convert";
import extend from "../../../../styles/Profile.module.css";
import { PiUser } from "react-icons/pi";
import { IoLockClosedOutline } from "react-icons/io5";
import UsernameToResetModal from "./UsernameToResetModal";
import NewPasswordConfirmModal from "./NewPasswordConfirmModal";
import invalidClass from "../../helperFunctions/helpers";
import {
  RESET_PASSWORD_MODE,
  RESET_PASSWORD_PENDING,
} from "../../../../constants/errorCodes";
import LoadingButton from "../LoadingButton/LoadingButton";

export default function Login2() {
  const usernameToResetModal = React.useRef(null);
  const newPasswordConfirmModal = React.useRef(null);
  const buttonLoginRef = React.useRef(null);
  const passwordFieldRef = React.useRef(null);

  const [file, setFile] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    //requestPermission();
  }, []);

  /** formik doesn't support file up`load so we need to create this handler */
  const onUpload = async (e) => {
    const base64 = await convertToBase64(e.target.files[0]);
    setFile(base64);
  };

  const imagePasswordState = () => {
    return showPassword ? <LuEyeOff /> : <LuEye />;
  };

  function togglePassword(event) {
    const newShowPassword = !showPassword;
    passwordFieldRef.current.type = newShowPassword ? "text" : "password";
    setShowPassword(!showPassword);
  }

  const processNewPasswordConfirmResult = (data) => {
    /*
     try login 
     {"esError":false,"codigoError":"","mensaje":"Reset Password Completado"}
     */

    formik.setFieldValue("username", data.username);
    formik.setFieldValue("password", data.password);

    buttonLoginRef.current.click();
  };

  const processResetModalResult = (data) => {
    console.log("--- " + data);
  };

  useEffect(() => {
    //document.body.style.backgroundColor = "red"
    //let className = `${innerStyle.body}`;

    let htmlTags = document.getElementsByTagName("html"); //.item(0)
    if (htmlTags.length > 0) {
      let htmlTag = htmlTags.item(0);
      htmlTag.classList.add(innerStyle.root);
    }

    document.body.classList.add(innerStyle.body);

    let root = document.getElementById("root");
    root.classList.add(innerStyle.body_root);

    let main = document.getElementsByTagName("main");
    if (main.length > 0) {
      main[0].classList.add(innerStyle.body_root);
    }

    // Clean up
    return () => {
      let htmlTags = document.getElementsByTagName("html"); //.item(0)
      if (htmlTags.length > 0) {
        let htmlTag = htmlTags.item(0);
        htmlTag.classList.remove(innerStyle.root);
      }

      document.body.classList.remove(innerStyle.body);

      let root = document.getElementById("root");
      root.classList.remove(innerStyle.body_root);

      let main = document.getElementsByTagName("main");
      if (main.length > 0) {
        main[0].classList.remove(innerStyle.body_root);
      }
    };

    //document.body.classNamList.add([])
  }, []);
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnMount: false,
    validateOnChange: false,
    validate: usernamePasswordLoginValidate,
    onSubmit: async (values, onSubmitProps) => {
      let username = values.username;
      let password = values.password;

      let loginPromise = api.login({
        username,
        password,
      });
      /*  toast.promise(loginPromise, {
        //toast.promise(loginPromise, {
        loading: "Checking...",
        success: <b>Login Successfully...!</b>,
        error: <b>Password Not Match</b>,
      });*/

      //toast.success("Successfully created!");

      setIsLoading(true);

      loginPromise
        .then(async (res) => {
          let { token } = res;
          localStorage.setItem("token", token);

          const decodedToken = await api.getUsername();
          const roleId = decodedToken.rolId;
          localStorage.setItem("roleId", roleId);
          const permissions = await api.rolesDetalles(roleId);

          const AdminRolId = 1;
          const { setState } = useAuthStore;

          const isAdmin = parseInt(roleId) === AdminRolId;

          setState({ permissions: permissions.data, isAdmin: isAdmin });

          useAuthStore.setState({ errorInfoStatusData: {} });

          setIsLoading(false);

          navigate("/protoApp");
        })
        .catch((error) => {
          setIsLoading(false);
          //toast.error(e.response.data.mensaje);
          console.log(error); // "oh, no!"
          if (error.codigoError === RESET_PASSWORD_PENDING) {
            //newPasswordConfirmModal.current.toggleModal();
            toast.error(error.mensaje);
          } else if (error.codigoError === RESET_PASSWORD_MODE) {
            newPasswordConfirmModal.current.toggleModal();
          } else {
            let message = error.mensaje || error.message;
            toast.error(message);
          }
        });
    },
  });

  return (
    <section className={innerStyle.section}>
      <Toaster position="top-center" reverseOrder={false}></Toaster>
      <UsernameToResetModal
        ref={usernameToResetModal}
        onOk={processResetModalResult}
      />
      <NewPasswordConfirmModal
        ref={newPasswordConfirmModal}
        username={formik.values.username}
        onOk={processNewPasswordConfirmResult}
      />
      <div className={`container ${innerStyle.container}`} style={{}}>
        <div
          className={`row align-items-center ${innerStyle.horizontalMargins} ${innerStyle.container}`}
        >
          <div
            className={`col-6 ${innerStyle.horizontalMargins}`}
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <img
              src={Logo}
              alt=""
              style={{
                width: "85%",
              }}
            />
            <img
              src={Bienvenido}
              alt=""
              style={{
                width: "85%",
              }}
            />
            <div></div>
          </div>
          <div
            className={`col-6 ${innerStyle.horizontalMargins}`}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="card col-9">
              <div className="card-body">
                <form className="row g-3">
                  <div className={`${innerStyle.floatingCircle}`}>
                    <div className={`${innerStyle.profile}`} style={{}}>
                      <label htmlFor="profile">
                        <img
                          className={`${styles.profile_img} ${extend.profile_img}`}
                          style={{
                            height: "75px",
                            width: "75px",
                          }}
                          src={file || iconoCamara}
                          alt="avatar"
                        />
                      </label>

                      <input
                        onChange={onUpload}
                        type="file"
                        id="profile"
                        name="profile"
                      />
                    </div>
                  </div>

                  <div
                    className={`col-md-12 ${innerStyle.topMarginForFloating}`}
                  >
                    <label
                      htmlFor="validationDefaultUsername"
                      className="form-label"
                      hidden
                    ></label>
                    <div className="input-group">
                      <span
                        className="input-group-text"
                        id="inputGroupPrepend2"
                      >
                        <PiUser />
                      </span>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.username,
                        )}`}
                        id="validationDefaultUsername"
                        aria-describedby="inputGroupPrepend2"
                        placeholder="Usuario"
                        {...formik.getFieldProps("username")}
                      />
                      <div className="invalid-feedback">
                        {formik.errors.username}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label
                      htmlFor="validationDefaultUsername"
                      className="form-label"
                      hidden
                    ></label>
                    <div className="input-group">
                      <span
                        className="input-group-text"
                        id="inputGroupPrepend2"
                      >
                        <IoLockClosedOutline />
                      </span>
                      <input
                        ref={passwordFieldRef}
                        type="password"
                        className={`form-control ${invalidClass(
                          formik.errors.password,
                        )}`}
                        id="validationDefaultUsername"
                        aria-describedby="inputGroupPrepend2"
                        placeholder="Password"
                        {...formik.getFieldProps("password")}
                      />
                      <span
                        className={`input-group-text ${invalidClass(
                          formik.errors.password,
                        )}`}
                        style={{
                          borderLefttWidth: "0px",
                          backgroundColor: "transparent",
                        }}
                        onClick={(e) => togglePassword(e)}
                      >
                        {imagePasswordState()}
                      </span>

                      <div className="invalid-feedback">
                        {formik.errors.password}
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <div className="col-12">
                      {/*  <button
                        ref={buttonLoginRef}
                        className="btn btn-primary"
                        style={{ margin: 0, width: "100%" }}
                        type="submit"
                        disabled={formik.isSubmitting}
                      >
                        Login
                      </button> */}
                      <LoadingButton
                        onClick={(e) => {
                          formik.handleSubmit();
                        }}
                        text={"Login"}
                        loadingText={"Login..."}
                        isLoading={isLoading}
                        style={{ margin: 0, width: "100%" }}
                      />
                    </div>

                    <div
                      className="mt-4 mb-4"
                      style={{ borderTop: "1px solid rgba(0, 0, 0, 0.15)" }}
                    ></div>

                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="button"
                      autoComplete="off"
                      style={{ margin: 0, width: "100%" }}
                      onClick={() => {
                        usernameToResetModal.current.toggleModal();
                      }}
                      disabled={isLoading}
                    >
                      Recuperar Contraseña
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
